<div class="payment-result-container">
	@if (status() === 'loading') {
		<div class="loading-state">
			<app-spinner [loading]="true">
				<div class="loading-content">
					<h2>{{ 'payment.result.processing' | transloco }}</h2>
					<p>{{ 'payment.result.processingSubtitle' | transloco }}</p>
				</div>
			</app-spinner>
		</div>
	}

	@if (status() === 'success') {
		<div class="result-state success">
			@if (isBrowser) {
				<ng-lottie [options]="successOptions" width="200px" height="200px" />
			}
			<h1>{{ 'payment.result.success' | transloco }}</h1>
			<p>{{ 'payment.result.successMessage' | transloco }}</p>
			@if (orderId()) {
				<p class="order-id">{{ 'payment.result.orderNumber' | transloco }} <strong>#{{ orderId() }}</strong></p>
			}
			<div class="actions">
				<app-button [label]="'payment.result.viewOrders' | transloco" (click)="goToOrders()" />
				<app-button [label]="'payment.result.placeAnother' | transloco" variant="secondary" (click)="goToBoost()" />
			</div>
		</div>
	}

	@if (status() === 'cancelled') {
		<div class="result-state cancelled">
			@if (isBrowser) {
				<ng-lottie [options]="errorOptions" width="200px" height="200px" />
			}
			<h1>{{ 'payment.result.cancelled' | transloco }}</h1>
			<p>{{ 'payment.result.cancelledMessage' | transloco }}</p>
			@if (orderId()) {
				<p class="order-id" [innerHTML]="'payment.result.orderNotCompleted' | transloco:{ orderId: orderId() }"></p>
			}
			<div class="actions">
				<app-button [label]="'payment.result.retry' | transloco" (click)="retryPayment()" />
				<app-button [label]="'payment.result.viewOrders' | transloco" variant="secondary" (click)="goToOrders()" />
			</div>
		</div>
	}

	@if (status() === 'error') {
		<div class="result-state error">
			@if (isBrowser) {
				<ng-lottie [options]="errorOptions" width="200px" height="200px" />
			}
			<h1>{{ 'payment.result.error' | transloco }}</h1>
			<p>{{ errorMessage() || ('payment.result.errorDefault' | transloco) }}</p>
			<div class="actions">
				<app-button [label]="'payment.result.retry' | transloco" (click)="retryPayment()" />
				<app-button [label]="'payment.result.viewOrders' | transloco" variant="secondary" (click)="goToOrders()" />
			</div>
		</div>
	}
</div>
